<template>
  <div
    class="leilao"
  >
    <div
      class="d-flex justify-center align-center"
      style="width: 100%"
      v-if="loading"
    >
      <v-progress-circular
        class="ma-9 mx-auto"
        color="primary"
        style="margin: 0 auto"
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-if="!loading">
      <AtivoLeilao
        v-if="isBetween"
      ></AtivoLeilao>
      <PreLeilao
        v-if="!isBetween"
      >
      </PreLeilao>
      <MoreDetails />
      <ProductSpecialist />
      <!-- Fique por Dentro -->
      <UpcomingAuctions></UpcomingAuctions>
      <v-card
        width="170"
        height="140"
        class="v-card--youtube"
        elevation="0"
      >
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube-nocookie.com/embed/VQRH6xM6T2o"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write;
              encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapMutations, mapState } from 'vuex';
import RegisterMixin from '@/mixins/RegisterMixin';
import UpcomingAuctions from '@/components/UpcomingAuctions/UpcomingAuctions.vue';
import MoreDetails from '@/views/leilao/components/MoreDetails';
import ProductSpecialist from '@/views/leilao/components/ProductSpecialist';
import AuctionsService from '@/services/AuctionsService';
import PreLeilao from './pre';
import AtivoLeilao from './ativo';

export default {
  name: 'Lote',
  components: {
    PreLeilao,
    AtivoLeilao,
    UpcomingAuctions,
    MoreDetails,
    ProductSpecialist,
  },
  mixins: [RegisterMixin],
  data() {
    return {
      loading: false,
      navigationItens: [],
      items: [
        {
          label: 'Button.EditProfile',
          icon: 'edit',
          action: () => {
            this.$router.push({
              name: this.$consts.ROUTES.BACKOFFICE_PROFILE_EDIT.NAME,
            });
          },
        },
        {
          label: 'Button.EditPassword',
          icon: 'lock',
          action: () => {
            this.$router.push({
              name: this.$consts.ROUTES.BACKOFFICE_PROFILE_PASSWORD_EDIT.NAME,
            });
          },
        },
        {
          label: 'Button.Logout',
          icon: 'logout',
          action: () => {
            this.logOut();
          },
        },
      ],
      title: '',
      firstName: '',
      email: '',
      sidebarMenu: false,
      lotStarted: false,
    };
  },
  watch: {
    '$route.params.lote': function () {
      this.getDetailsLot();
    },
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    ...mapState('Data/Auctions', [
      'auction',
      'lot',
    ]),
  },
  created() {
    if (!this.auction) {
      this.loading = true;
      AuctionsService.setAuction({
        id: this.$route.params.leilao,
        slug: this.$route.params.leilao,
      });
      AuctionsService.getAuctionDetails()
        .then(() => {
          this.getDetailsLot();
        })
        .catch(() => {
        });
    } else {
      this.getDetailsLot();
    }
  },
  methods: {
    ...mapMutations('Data/Auctions', [
      'setPage',
      'setBids',
    ]),
    getDetailsLot() {
      this.loading = true;
      this.setPage(this.$route.params.lote);
      this.setBids([]);
      AuctionsService.getAuctionsLotsDetails()
        .then(() => {
          AuctionsService.getAuctionsBids();
          this.loading = false;
          // console.log(this.isBetween(this.lot));
        })
        .catch((error) => {
          throw error;
        });
    },
    gotoLote(n) {
      // console.log(n);
      // this.setPage(n);
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
        params: {
          lote: n,
        },
      });
    },
    isBetween(lot) {
      const now = moment();
      const startDate = moment.unix(lot.starts_at);
      const endDate = moment.unix(lot.ends_at);
      return now.isBetween(startDate, endDate);
    },
    logOut() {
      this.$router.push({ name: this.$consts.ROUTES.AUTH_LOGIN.NAME });
    },
  },
};
</script>
<style lang="scss">
@import '@/static/css/Variables.scss';
.v-card {
  &--youtube {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 5;
  }
}
</style>
